<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'CustomerList' }" class="nav-link">Klienci</router-link>/<span v-if="item && !loading">{{ item['name'] }}</span></h2>
            <div v-if="item && !loading" class="page-title__buttons">
                <router-link :to="{name: 'CustomerUpdate', params: { id: item['id'] }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
            </div>
		</page-title>

        <div class="col page-element">    
            <alert-loading v-if="loading"></alert-loading>
            <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign"
                                                                            aria-hidden="true"></span> {{ error }}
            </div>
            <div v-if="deleteError" class="alert alert-danger" role="alert"><span
                    class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ deleteError }}
            </div>            
            <div v-if="item && !loading" class="row">
                <div class="col-md-6">
                    <table class="table table-data">
                        <tbody>
                        <tr>
                            <td>Nazwa</td>
                            <td>{{ item['name'] }}</td>
                        </tr>
                        <tr>
                            <td>NIP</td>
                            <td>{{ item['nip'] }}</td>
                        </tr>
                        <tr v-if="item['regon']">
                            <td>REGON</td>
                            <td>{{ item['regon'] }}</td>
                        </tr>
                        <tr v-if="item['pesel']">
                            <td>PESEL</td>
                            <td>{{ item['pesel'] }}</td>
                        </tr>
                        <tr v-if="item['krs']">
                            <td>KRS</td>
                            <td>{{ item['krs'] }}</td>
                        </tr>

                        <tr v-if="item.bankAccount.numberPLN">
                            <td>Numer konta (PLN)</td>
                            <td>{{ item.bankAccount.numberPLN }}</td>
                        </tr>
                        <tr v-if="item.bankAccount.numberEUR">
                            <td>Numer konta (EUR)</td>
                            <td>{{ item.bankAccount.numberEUR }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-6">
                    <table class="table table-data">
                        <tbody>
                        <tr>
                            <td>Adres</td>
                            <td>{{ item.address.postalCode }} {{ item.address.city }}, ul. {{ item.address.street
                                }} {{ item.address.number }}
                            </td>
                        </tr>
                        <tr>
                            <td>Telefon</td>
                            <td>{{ item.contact.phone }}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>{{ item.contact.email }}</td>
                        </tr>
                        <tr>
                            <td>Prowizja</td>
                            <td>{{ item['commission'] | percentage}}</td>
                        </tr>
                        <tr v-if="item.comments">
                            <td>Uwagi</td>
                            <td>{{ item['comments'] }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <agreement-list v-if="item && !loading" :id="item['id']"></agreement-list>

        <customer-document-list v-if="item && !loading" :id="item['id']"></customer-document-list>

    </b-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        deleteError: 'customer/del/error',
        error: 'customer/show/error',
        loading: 'customer/show/loading',
        item: 'customer/show/item',
      })
    },
    methods: {
      deleteItem (item) {
        if (window.confirm('Czy na pewno chce usunąć tego klienta?'))
          this.$store.dispatch('customer/del/delete', item).then(response => this.$router.push({name: 'CustomerList'}))
      }
    },
    created () {
      this.$store.dispatch('customer/show/retrieve', this.$route.params.id)
    },
    beforeDestroy () {
      this.$store.dispatch('customer/show/reset')
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?51497000